/**
 * Recipient role priority: which contact role a bulk action picks first. The role keys and their
 * German labels come from the backend vocabulary (globalHooks/useContactRoles).
 */

// All roles enabled, Geschäftsführung first, Firma last — the closest analog of the previous
// hardcoded "bester Kontakt" behavior.
export const DEFAULT_ROLE_PRIORITY = [
	'ceo',
	'prokura',
	'sales',
	'marketing',
	'buyer',
	'hr',
	'it',
	'engineering',
	'finance',
	'operations',
	'company',
];

/**
 * Drops keys that are no longer valid picker options (e.g. stale persisted localStorage state
 * after a role rename) so they never reach the API.
 *
 * @param {string[]|null|undefined} keys
 * @returns {string[]} the sanitized list, or the default priority when nothing valid remains
 */
export const sanitizeRolePriority = (keys) => {
	const validKeys = new Set(DEFAULT_ROLE_PRIORITY);
	const sanitized = (keys ?? []).filter((key) => validKeys.has(key));
	return sanitized.length > 0 ? sanitized : DEFAULT_ROLE_PRIORITY;
};
